import { Box, Link } from "@mui/material";
import { FC } from "react";
import FilePresentOutlinedIcon from "@mui/icons-material/FilePresentOutlined";
import DownloadIcon from "@mui/icons-material/Download";

interface Props {
  label: string;
  href: string;
}

const PdfDownloadCell: FC<Props> = ({ label, href }) => {
  return (
    <>
      <Box
        display={{ xs: "none", md: "flex" }}
        sx={{ alignItems: "center", cursor: "pointer" }}
      >
        <FilePresentOutlinedIcon fontSize="small" color="primary" />

        <Link
          target="_blank"
          href={href}
          sx={{
            paddingLeft: 1,
            textDecoration: "none",
            fontWeight: 600,
            lineHeight: 1,
          }}
        >
          {label}
        </Link>
      </Box>
      <Box
        display={{ xs: "block", md: "none" }}
        width="100%"
        textAlign="center"
      >
        <Link target="_blank" href={href}>
          <DownloadIcon htmlColor="#1684FF" />
        </Link>
      </Box>
    </>
  );
};

export default PdfDownloadCell;
